module.exports = __webpack_public_path__ + "static/media/mastercard.93ce0c2b.svg";